import React from "react";
import InterventionsDataManager from "../../../components/DataManagers/InterventionsDataManager";
import styles from "./style.module.scss";
import SessionStatus from "../../../components/Timing/SessionStatus";
import SessionInfo from "../../../components/Timing/SessionInfo";
import SessionFlags from "../../../components/Timing/SessionFlags";
import Leaderboard from "../../../components/Timing/Leaderboard";
import RaceControl from "../../../components/Timing/RaceControl";
import Weather from "../../../components/Timing/Weather";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import AuthenticatedLayout from "../../../components/Layout/authenticatedLayout";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";
import LoopHeatMap from "../../../components/Timing/LoopHeatMap";
import { FiExternalLink } from "react-icons/fi";

function TimingPage() {
  return (
    <AuthenticatedLayout title={"Timing"} showJaguarLogo={false}>
      <TimingDataManager />
      <ImportsDataManager />
      <InterventionsDataManager />
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.sessionStatusWrapper}>
            <SessionInfo />
            <SessionStatus />
          </div>
          <RaceControl />
          <Weather />
          <Leaderboard />
          <SessionFlags />
          <div className={styles.loopHeatMapWrapper}>
            <LoopHeatMap />
            <button
              className={styles.pageLink}
              onClick={() => window.open("/loop-heatmap", "_blank")}
            >
              Open Compact Version <FiExternalLink />
            </button>
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}

export default TimingPage;
